import { render } from "./PatientsDatatableTDTreatmentStatus.vue?vue&type=template&id=761d7172&scoped=true"
import script from "./PatientsDatatableTDTreatmentStatus.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDTreatmentStatus.vue?vue&type=script&lang=js"

import "./PatientsDatatableTDTreatmentStatus.vue?vue&type=style&index=0&id=761d7172&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761d7172"]])

export default __exports__